import { cn } from '@/lib/utils'

interface MetricPart {
  value: string | number
  label: string
}

interface FormattedMetricProps {
  parts: MetricPart[]
  className?: string
}

/**
 * Formats a metric with styled count/label pairs.
 * The count is displayed in the default metric style (large, bold),
 * while the label is smaller and lighter in color.
 *
 * Example: FormattedMetric({ parts: [{ value: '2', label: 'h' }, { value: '34', label: 'm' }] })
 * Renders as: 2h 34m (with styled labels)
 */
export function FormattedMetric({ parts, className }: FormattedMetricProps) {
  return (
    <div className={cn('flex items-baseline gap-1.5', className)}>
      {parts.map((part, index) => (
        <div key={index} className="flex items-baseline">
          <span className="text-4xl font-bold tabular-nums text-gray-900 dark:text-foreground">
            {part.value}
          </span>
          <span className="text-2xl font-bold text-gray-700 dark:text-muted-foreground ml-0.5">
            {part.label}
          </span>
        </div>
      ))}
    </div>
  )
}
